<template>
    <div>
        <div class="d-flex align-center flex-wrap">
            <v-badge :value="activeCount > 0" :content="activeCount" color="primary" overlap>
                <v-btn icon :color="open ? 'primary' : undefined" @click="open = !open" title="Filtros">
                    <v-icon>filter_list</v-icon>
                </v-btn>
            </v-badge>

            <v-chip v-if="value.alerts == ALERTS.WITH" small close class="ml-2" color="red" text-color="white" @click:close="update({ alerts: ALERTS.ALL })">
                <v-icon small left>error</v-icon>Com alerta
            </v-chip>
            <v-chip v-if="value.alerts == ALERTS.WITHOUT" small close class="ml-2" color="green" text-color="white" @click:close="update({ alerts: ALERTS.ALL })">
                <v-icon small left>check_circle</v-icon>Sem alerta
            </v-chip>
            <v-chip v-if="value.payments == PAYMENTS.WITH" small close class="ml-2" @click:close="update({ payments: PAYMENTS.ALL })">
                <v-icon small left>credit_card</v-icon>Com pagamento
            </v-chip>
            <v-chip v-if="value.payments == PAYMENTS.WITHOUT" small close class="ml-2" @click:close="update({ payments: PAYMENTS.ALL })">
                <v-icon small left>smartphone</v-icon>Sem pagamento
            </v-chip>
            <v-chip v-if="value.empty == EMPTY.HIDE" small close class="ml-2" :title="EMPTY_HINT" @click:close="update({ empty: EMPTY.ALL })">
                <v-icon small left>visibility_off</v-icon>Sem vazios
            </v-chip>
            <v-chip v-if="value.empty == EMPTY.ONLY" small close class="ml-2" :title="EMPTY_HINT" @click:close="update({ empty: EMPTY.ALL })">
                <v-icon small left>block</v-icon>Só vazios
            </v-chip>
            <v-chip v-for="point in value.points" :key="point" small close class="ml-2" @click:close="update({ points: value.points.filter((p) => p != point) })">
                <v-icon small left>place</v-icon>{{ point }}
            </v-chip>
            <v-chip v-if="value.search" small close class="ml-2" @click:close="clearSearch">
                <v-icon small left>search</v-icon>{{ value.search }}
            </v-chip>
        </div>

        <v-expand-transition>
            <!-- v-show fica no wrapper porque o d-flex usa display !important e impediria de esconder -->
            <div v-show="open">
                <div class="d-flex align-center flex-wrap pt-2 filter-panel">
                    <v-btn-toggle :value="value.alerts" :color="alertColor" mandatory dense class="mr-6" @change="update({ alerts: $event })">
                        <v-btn small :value="ALERTS.ALL">Todos</v-btn>
                        <v-btn small :value="ALERTS.WITH"><v-icon small left color="red">error</v-icon>Com alerta</v-btn>
                        <v-btn small :value="ALERTS.WITHOUT"><v-icon small left color="green">check_circle</v-icon>Sem alerta</v-btn>
                    </v-btn-toggle>
                    <v-btn-toggle :value="value.payments" color="primary" mandatory dense class="mr-6" @change="update({ payments: $event })">
                        <v-btn small :value="PAYMENTS.ALL">Todos</v-btn>
                        <v-btn small :value="PAYMENTS.WITH"><v-icon small left>credit_card</v-icon>Com pagamento</v-btn>
                        <v-btn small :value="PAYMENTS.WITHOUT"><v-icon small left>smartphone</v-icon>Sem pagamento</v-btn>
                    </v-btn-toggle>
                    <v-btn-toggle :value="value.empty" color="primary" mandatory dense class="mr-6" :title="EMPTY_HINT" @change="update({ empty: $event })">
                        <v-btn small :value="EMPTY.ALL">Todos</v-btn>
                        <v-btn small :value="EMPTY.HIDE"><v-icon small left>visibility_off</v-icon>Ocultar vazios</v-btn>
                        <v-btn small :value="EMPTY.ONLY"><v-icon small left>block</v-icon>Só vazios</v-btn>
                    </v-btn-toggle>
                    <v-autocomplete :value="value.points" :items="pointOptions" label="Local" prepend-inner-icon="place" multiple small-chips deletable-chips clearable hide-details dense outlined class="mr-4 filter-points" @change="update({ points: $event || [] })" />
                    <v-text-field v-model="search" label="Carregador, e-mail, NFC ou transação" prepend-inner-icon="search" clearable hide-details dense outlined class="filter-search" />
                </div>
            </div>
        </v-expand-transition>
    </div>
</template>

<script>
import { ALERTS, EMPTY, PAYMENTS } from "./shared/filters";

const SEARCH_DEBOUNCE = 400;
const EMPTY_HINT = "Vazios: sem transação, pagamento e usuário, e sem tempo carregando";

export default {
    name: "FilterBar",

    props: {
        value: { type: Object, required: true },
        points: { type: Array, default: () => [] },
    },

    data() {
        return {
            ALERTS,
            EMPTY,
            EMPTY_HINT,
            PAYMENTS,
            open: false,
            search: this.value.search,
            searchTimer: null,
        };
    },

    beforeDestroy() {
        clearTimeout(this.searchTimer);
    },

    methods: {
        update(changes) {
            this.$emit("input", { ...this.value, ...changes });
        },
        clearSearch() {
            this.search = "";
            this.update({ search: "" });
        },
    },

    computed: {
        activeCount() {
            return (this.value.alerts != ALERTS.ALL ? 1 : 0) + (this.value.payments != PAYMENTS.ALL ? 1 : 0) + (this.value.empty != EMPTY.ALL ? 1 : 0) + this.value.points.length + (this.value.search ? 1 : 0);
        },
        alertColor() {
            if (this.value.alerts == ALERTS.WITH) return "red";
            if (this.value.alerts == ALERTS.WITHOUT) return "green";
            return "primary";
        },
        pointOptions() {
            // Mantém os locais selecionados mesmo sem sessões no momento
            return [...new Set([...this.points, ...this.value.points])].sort();
        },
    },

    watch: {
        search(val) {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => this.update({ search: val || "" }), SEARCH_DEBOUNCE);
        },
        "value.search"(val) {
            if (val != (this.search || "")) this.search = val;
        },
    },
};
</script>

<style scoped>
.filter-panel {
    row-gap: 8px;
}

.filter-points {
    min-width: 320px;
    max-width: 600px;
}

.filter-search {
    max-width: 320px;
}
</style>
